import FeatureGates from "@atlaskit/feature-gate-js-client";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { ALM_INTEGRATION_FF } from "src/constants";
import { ADOBE_ACCESS_TOKEN_LS_KEY, fetchAdobeToken, getAdobeToken } from "src/services/http/adobeAuth";

export const useAdobeAuth = (): void => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!FeatureGates.checkGate(ALM_INTEGRATION_FF)) {
      return;
    }

    if (getAdobeToken()) {
      return;
    }

    const handleAuth = async (): Promise<void> => {
      const queryParams = new URLSearchParams(globalThis.location.search);
      const primeBase = queryParams.get('PRIME_BASE');
      const code = queryParams.get('code');

      if (code) {
        const responseData = await fetchAdobeToken(code);

        if (responseData.access_token) {
          localStorage.setItem(ADOBE_ACCESS_TOKEN_LS_KEY, responseData.access_token);
        }
      }

      if (primeBase) {
        navigate('/');
      }
    };

    handleAuth();
  }, [navigate]);
};
